import { MixedItem, RBAssetType } from 'store/railsBuilder/reducer.types';

import { EventItemWithServiceInfo } from 'services/data-manager/types';

import { DetailsRequestUrlType } from 'screens/Detail/types';

function getRBChannelItemDetailsParams({
    currentEvent,
}: EventItemWithServiceInfo): MixedItem['detailsPageParams'] {
    if (currentEvent) {
        const { id, type, serviceRef, contentRef, editorial } = currentEvent;

        if (editorial?.seriesRef) {
            return {
                filterType: DetailsRequestUrlType.PROGRAM,
                id,
                seriesId: editorial.seriesRef,
                channelId: serviceRef,
                programId: editorial?.technicals?.[0]?.ProgramId,
                season: editorial?.SeasonNumber,
                episode: editorial?.episodeNumber,
            };
        }

        const contentId = contentRef || id;

        if (type === RBAssetType.EDITORIAL) {
            return {
                filterType: DetailsRequestUrlType.VOD,
                id,
                editorialId: contentId,
                programId: editorial?.technicals?.[0]?.ProgramId,
                channelId: serviceRef,
            };
        }

        if (type === RBAssetType.PROGRAMME) {
            return {
                filterType: DetailsRequestUrlType.PROGRAM,
                id,
                channelId: serviceRef,
            };
        }

        if (contentId) {
            return {
                filterType: DetailsRequestUrlType.VOD,
                id,
                contentRef: contentId,
                channelId: serviceRef,
            };
        }

        return {
            filterType: DetailsRequestUrlType.PROGRAM,
            id,
            channelId: serviceRef,
        };
    }

    return undefined;
}

export default getRBChannelItemDetailsParams;
